<template>
    <div>
<!--    <div class="row row-cols-1 mt-4">-->
<!--        <div class="col">-->
        <strong class="text-muted"><i class="fa-solid fa-lock"></i> Trade Protection™</strong>
        <div class="d-grid grid-0">
            <button
                class="btn"
                :class="[trade.actionNeeded ? ['btn-warning', 'shadow'] : 'btn-outline-secondary']"
                data-bs-toggle="modal" :data-bs-target="'#tc-' + trade.id">
                status:
                <strong v-if="trade.actionNeeded">ACTION REQUIRED</strong>
                <strong v-else>{{ trade.status.toUpperCase() }}</strong>

                <small class="d-block">click for more details</small>
            </button>
        </div>
<!--        </div>-->

        <div class="modal fade" :id="'tc-' + trade.id" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Trade Protection™ <small>(Trade ID: {{ trade.id }})</small></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="trade.status === 'confirm'">
                            <!-- <div v-if="trade.receiving.condition === 'verified'" class="alert alert-success"><i class="fa-solid fa-circle-check"></i> Pin &amp; Pop have graded this pin's condition as: <strong>VERIFIED</strong></div> -->
                            <div v-if="trade.receiving.verify.authenticity === 'authentic'" class="alert alert-success">
                                <p><i class="fa-solid fa-circle-check"></i> Pin &amp; Pop have verified this pin as: <strong>AUTHENTIC</strong></p>
                                <div v-if="trade.receiving.verify.notes">
                                    <strong>NOTE: </strong> {{ trade.receiving.verify.notes }}
                                </div>
                                <div class="mt-2 small">Contact <a href="mailto:support@pinandpop.com">support@pinandpop.com</a> if you need additional details.</div>
                            </div>
                            <div v-else-if="trade.receiving.verify.authenticity === 'fantasy'" class="alert alert-primary">
                                <p><i class="fa-solid fa-hat-wizard"></i> Pin &amp; Pop have verified this pin as a: <strong>FANTASY Pin</strong></p>
                                <div v-if="trade.receiving.verify.notes">
                                    <strong>NOTE: </strong> {{ trade.receiving.verify.notes }}
                                </div>
                                <div class="mt-2 small">Contact <a href="mailto:support@pinandpop.com">support@pinandpop.com</a> if you need additional details.</div>
                            </div>
                            <div v-else class="alert alert-warning">
                                <!-- <p><i class="fa-solid fa-triangle-exclamation"></i> Pin &amp; Pop have graded this pin's condition as: <strong>{{ trade.receiving.condition.toUpperCase() }}</strong></p> -->
                                <p><i class="fa-solid fa-triangle-exclamation"></i> Pin &amp; Pop have verified this pin as: <strong>{{ trade.receiving.verify.authenticity.toUpperCase() }}</strong></p>
                                <!-- <div v-if="trade.receiving.notes"> -->
                                    <!-- <strong>NOTE: </strong> {{ trade.receiving.notes }} -->
                                <div v-if="trade.receiving.verify.notes">
                                    <strong>NOTE: </strong> {{ trade.receiving.verify.notes }}
                                </div>
                                <div class="mt-2 small">Contact <a href="mailto:support@pinandpop.com">support@pinandpop.com</a> if you need additional details.</div>
                            </div>
                            <div class="mt-3">Click each image to view more detail...</div>
                            <!-- <a v-for="pic in trade.receiving.images" :key="pic.id" :href="'https://pinandpop.s3.amazonaws.com/' + pic.path + 'pins/' + pic.name" target="_blank">
                                <picture>
                                    <source :srcset="'https://pinandpop.s3.amazonaws.com' + pic.thumbs.webp" type="image/webp">
                                    <source :srcset="'https://pinandpop.s3.amazonaws.com' + pic.thumbs.jpg" type="image/jpeg">
                                    <img class="" :src="'https://pinandpop.s3.amazonaws.com' + pic.thumbs.jpg" :alt="trade[trade.primary].name">
                                </picture></a> -->
                            <a v-for="pic in trade.receiving.verify.photos" :key="pic.id" :href="'https://neverwood.nyc3.cdn.digitaloceanspaces.com/lg/' + pic.lg_file" target="_blank">
                                <picture>
                                    <source :srcset="pic.srcset.webp" type="image/webp">
                                    <!-- <source :srcset="pic.srcset.jpg" type="image/jpeg"> -->
                                    <img class="p-2" :src="pic.srcset.jpg" :alt="trade[trade.primary].name">
                                </picture></a>
                        </div>
                        <div v-else>
                            <ul class="list-group">
                                <li class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> Accepted Trade</span> <strong>{{ trade.history.created }}</strong></li>

                            <!-- <template v-if="trade.check.length"> -->
                            <template v-if="trade.shipping || trade.receiving">
                                <li v-if="trade.history.secondary_received" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&amp;P Received Your Package</span> <strong>{{ trade.history.secondary_received }}</strong></li>
                                <template v-else>
                                <li class="list-group-item" :class="{'list-group-item-success': autoVerify}">
                                    <!-- <i class="fa-regular" :class="autoVerify ? 'fa-square-check' : 'fa-square'"></i>  -->
                                    <strong> Auto Accept Verified?</strong>
                                    <div class="form-text">Auto accept trades that PIN & POP verifies as authentic and in good condition (photos will not be provided).</div>
                                    <div class="mt-3 text-center">
                                        <div class="form-check form-check-inline border border-secondary rounded">
                                            <label class="form-check-label p-2" :class="{'fw-bold': autoVerify}" :for="'autoVerify-' + trade.id">
                                                <input @change="toggleAutoVerify" class="form-check-input me-2" type="checkbox" v-model="autoVerify" :id="'autoVerify-' + trade.id">
                                                Yes, auto accept my verified trades
                                            </label>
                                        </div>
                                    </div>
                                </li>
                                <li v-if="trade.history.secondary_inbound" class="list-group-item list-group-item-warning"><i class="fa-regular fa-square"></i> Waiting to receive pin from you
                                    <div v-if="trade.shipping.inbound_tracking" class="small">
                                        Tracking:
                                        <a v-if="trade.shipping.inbound_tracking.replace(/[^\d]+/g, '').length > 6" :href="'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + trade.shipping.inbound_tracking" target="_blank">{{ trade.shipping.inbound_tracking }}</a>
                                        <span v-else>{{ trade.shipping.inbound_tracking }}</span>
                                    </div>
                                </li>
                                <li v-else class="list-group-item list-group-item-warning"><i class="fa-regular fa-square"></i> After the event, ship your pins to:
                                    <div class="my-2 px-4 py-2 bg-light">
                                        <div>Pin &amp; Pop</div>
                                        <div>{{ shipping.address }}</div>
                                        <div v-if="shipping.address_2">{{ shipping.address_2 }}</div>
                                        <div>{{ shipping.city }} {{ shipping.state }}, {{ shipping.zip }}</div>
                                        <div v-if="shipping.country">{{ shipping.country }}</div>
                                    </div>
                                    <label :for="'tracking-for-' + trade.shipping.id" class="form-label small mt-2 mb-0 d-block">
                                        Shipping Tracking:
                                        <strong v-if="trackingError" class="text-danger ms-2">Enter Tracking Number</strong>
                                    </label>
                                    <div class="input-group">
                                        <input type="text" class="form-control data-hj-allow" :id="'tracking-for-' + trade.shipping.id" placeholder="Enter Tracking Number" v-model="trade.shipping.inbound_tracking">
                                        <button @click="shippedMyPin" type="button" class="btn btn-dark btn-sm">SAVE</button>
                                    </div>
                                </li>
                                </template>

                                <li v-if="trade.history.secondary_confirmed" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&amp;P Confirmed Your Pin</span> <strong>{{ trade.history.secondary_confirmed }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&amp;P Confirms Your Pin</li>

                                <li v-if="trade.history.secondary_confirmed && trade.history.secondary_verified" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.shipping.condition === 'scrapper' ? 'list-group-item-warning' : 'list-group-item-success']"><span><i class="fa-regular fa-square-check"></i> P&amp;P Inspected Your Pin</span> <strong>{{ trade.history.secondary_verified }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&amp;P Inspects Your Pin</li>

                                <li v-if="trade.history.secondary_response" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.shipping.response === 'approved' ? 'list-group-item-success' : 'list-group-item-danger']">
                                    <span>
                                        <i class="fa-regular" :class="[trade.shipping.response === 'approved' ? 'fa-check-square' : 'fa-square']"></i>
                                        They <span v-if="!trade.shipping.has_processing">Auto </span>
                                        <strong>{{ trade.shipping.response.toUpperCase() }}</strong></span>
                                    <strong>{{ trade.history.secondary_response }}</strong>
                                </li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> They <span v-if="!trade.shipping.has_processing">Auto </span>Approve Trade</li>

                                <li v-if="trade.history.primary_received" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&amp;P Received Their Package</span> <strong>{{ trade.history.primary_received}}</strong></li>
                                <li v-else class="list-group-item list-group-item-warning"><i class="fa-regular fa-square"></i> Waiting to receive their pin</li>
                                
                                <li v-if="trade.history.primary_confirmed" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&amp;P Confirmed Their Pin</span> <strong>{{ trade.history.primary_confirmed }}</strong></li>
                                <li v-else class="list-group-item list-group-item-warning"><i class="fa-regular fa-square"></i> P&amp;P Confirms Their Pin</li>
                                <!-- <li v-if="trade.history.primary_confirmed && trade.history.primary_verified" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.receiving.condition === 'verified' ? 'list-group-item-success' : 'list-group-item-warning']"><span><i class="fa-regular fa-square-check"></i> P&amp;P Inspected Their Pin: <strong>{{ trade.receiving.condition.toUpperCase() }}</strong></span> <strong>{{ trade.history.primary_verified }}</strong></li> -->
                                <li v-if="trade.history.primary_confirmed && trade.history.primary_verified" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.receiving.verify.authenticity === 'authentic' ? 'list-group-item-success' : 'list-group-item-warning']"><span><i class="fa-regular fa-square-check"></i> P&amp;P Inspected Their Pin: <strong>{{ trade.receiving.verify.authenticity.toUpperCase() }}</strong></span> <strong>{{ trade.history.primary_verified }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&amp;P Inspects Their Pin</li>

                                <li v-if="trade.history.primary_response" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.receiving.response === 'approved' ? 'list-group-item-success' : 'list-group-item-danger']">
                                    <span>
                                        <i class="fa-regular" :class="[trade.receiving.response === 'approved' ? 'fa-check-square' : 'fa-square']"></i> 
                                        You <span v-if="!trade.receiving.has_processing">Auto </span>
                                        <strong>{{ trade.receiving.response.toUpperCase() }}</strong></span>
                                    <strong>{{ trade.history.primary_response }}</strong>
                                </li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> You <span v-if="!trade.receiving.has_processing">Auto </span>Approve Trade</li>

                                <template v-if="trade.shipping.response === 'rejected' || trade.receiving.response === 'rejected'">
                                <li v-if="trade.history.secondary_shipped" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&amp;P Shipped Original Pin</span> <strong>{{ trade.history.secondary_shipped }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&amp;P Ships Original Pin</li>
                                <li v-if="trade.shipping.shipping_tracking" class="list-group-item text-center">Shipping Tracking:
                                    <h3>
                                        <a v-if="trade.shipping.shipping_tracking.replace(/[^\d]+/g, '').length > 6" :href="'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + trade.shipping.shipping_tracking" target="_blank">{{ trade.shipping.shipping_tracking }}</a>
                                        <span v-else>{{ trade.shipping.shipping_tracking }}</span>
                                    </h3>
                                </li>
                                </template>
                                <template v-else>
                                <li v-if="trade.history.primary_shipped" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&amp;P Shipped New Pin</span> <strong>{{ trade.history.primary_shipped }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&amp;P Ships New Pin</li>
                                <li v-if="trade.receiving.shipping_tracking" class="list-group-item text-center">Shipping Tracking:
                                    <h3>
                                        <a v-if="trade.receiving.shipping_tracking.replace(/[^\d]+/g, '').length > 6" :href="'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + trade.receiving.shipping_tracking" target="_blank">{{ trade.receiving.shipping_tracking }}</a>
                                        <span v-else>{{ trade.receiving.shipping_tracking }}</span>
                                    </h3>
                                </li>
                                </template>
                            </template>

                            </ul>
                            <div v-if="!trade.shipping && !trade.receiving" class="alert alert-info mt-3">Additional details are not <span v-if="trade.id > 150">yet</span> available for this trade.</div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-link me-auto" data-bs-dismiss="modal">Close</button>
                        <span v-if="trade.status === 'confirm'">
                            <button type="button" @click="rejectTrade" class="btn btn-danger me-3">Reject Trade</button>
                            <button type="button" @click="approveTrade" class="btn btn-success">Approve Trade</button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TradeCheck",
    props: ['tradedata', 'shipping'],
    data() {
        return {
            trade: Vue.util.extend({}, this.tradedata),
            trackingError: false,
            confirmResponse: false,
            autoVerify: false
        }
    },
    methods: {
        toggleAutoVerify() {
            axios.put( '/my/orders/check/' + this.trade.receiving.id, {
                'auto_verify': this.autoVerify
            }).then(response => {
                if (response.status === 200) {
                    console.log(this.autoVerify);
                }
            }).catch(error => {
                this.handleError(error);
            });
        },
        shippedMyPin: function() {
            const now = new Date();
            const tracking = this.trade.shipping.inbound_tracking;
            this.trackingError = false;

            if (tracking) {
                axios.put( '/my/orders/check/' + this.trade.shipping.id, {
                    tracking: this.trade.shipping.inbound_tracking
                }).then(response => {
                    if (response.status === 200) {
                        this.trade.history.secondary_inbound = now.toISOString().substring(0, 10);
                        // if (!this.trade.receiving.shipped_at) {
                            this.trade.actionNeeded = false;
                        // }

                        localStorage.setItem('tradeShip', JSON.stringify({ 
                            "track": this.trade.shipping.inbound_tracking,
                            "u": this.trade.shipping.user_id,
                            "t": now.getTime()
                        }));
                    }
                }).catch(error => {
                    this.handleError(error);
                });
            } else {
                this.trackingError = true;
            }
        },
        approveTrade: function() {
            if (confirm('Are you sure you want to APPROVE the trade?')) {
                axios.put( '/my/orders/check/' + this.trade.receiving.id, {
                    response: 'approved'
                }).then(response => {
                    if (response.status === 200) {
                        this.setTradeConfirm('approved');
                    }
                }).catch(error => {
                    this.handleError(error);
                });
            }
        },
        rejectTrade: function() {
            if (confirm('Are you sure you want to REJECT the trade?')) {
                axios.put( '/my/orders/check/' + this.trade.receiving.id, {
                    response: 'rejected'
                }).then(response => {
                    if (response.status === 200) {
                        this.setTradeConfirm('rejected');
                    }
                }).catch(error => {
                    this.handleError(error);
                });
            }
        },
        setTradeConfirm: function(response) {
            let now = new Date().toISOString().substring(0, 10);
            this.trade.status = 'processing';
            this.trade.actionNeeded = false;
            this.trade.history.primary_response = now;
            this.trade.receiving.response_at = now;
            this.trade.receiving.response = response;
        },
        handleError: function(error) {
            if (error.response.status === 401) {
                window.location.href = '/login?intended='+window.location.pathname;
            } else if (error.response.status === 419) {
                window.location.reload();
            }
        }
    },
    mounted() {
        if (this.trade.receiving && this.trade.receiving.images) {
            this.trade.receiving.images = this.trade.receiving.images.sort((a, b) => b.is_primary - a.is_primary);
        }

        this.autoVerify = this.trade.receiving && !this.trade.receiving.has_processing;

        document.getElementById('tc-' + this.trade.id).addEventListener('show.bs.modal', () => {
            if (localStorage.tradeShip && !this.trade.shipping.inbound_tracking) {
                const now = new Date();
                let tradeShip = JSON.parse(localStorage.getItem('tradeShip'));
                if (Math.abs(Math.round(((now.getTime() - tradeShip.t) / 1000) / 60)) < 30 && tradeShip.u === this.trade.shipping.user_id) {
                    this.trade.shipping.inbound_tracking = tradeShip.track;
                } else {
                    localStorage.removeItem('tradeShip');
                }
            }
        });
    }
}
</script>
